import type { RouteDef } from '../../../dashboardDef';

/** Defines the redirect behavior for top navigation routes by routing to the first accessible child route */
const getRoutesWithRedirect = (routes: RouteDef[]): RouteDef[] => {
  return routes.map((nav) => {
    const firstAccessibleRoute = nav.routes ? nav.routes[0] : null;
    if (firstAccessibleRoute) {
      nav.redirect = firstAccessibleRoute.redirect || firstAccessibleRoute.url;
    }
    return nav;
  });
};

export default getRoutesWithRedirect;
